import { plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import type { IInspectionTemplateOverview } from './IInspectionTemplateOverview'

export class InspectionTemplateOverview extends Entity<IInspectionTemplateOverview> {
  templateId: number

  templateName: string

  stats: {
    scheduled: number
    overdue: number
    completed: number
    openTasks: number
  }

  linkedRegisters: Array<{
    id: number
    name: string
  }>

  public static new(payload: unknown): InspectionTemplateOverview {
    return plainToInstance(InspectionTemplateOverview, payload)
  }
}
